import dateService from "../../../../../../../../common/utils/date/date.service";
import durationService from "../../../../../../../../common/utils/duration/duration.service";
import orderTranslationsHelper from "../../../../../../../../languages/order-translations.helper";

const getAddressLabel = (addressDisplayName: string) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .insertNodeAfter.addressTemplateText;

  return translations.replace("#{addressDisplayName}", addressDisplayName);
};

const getAddressTitle = (addressDisplayName: string) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .insertNodeAfter.addressTemplateText;

  return translations.replace("#{addressDisplayName}", addressDisplayName);
};

const getPlannedDateLabel = (plannedDate: Date | null) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .insertNodeAfter.dateTemplateText;

  const formattedDate = plannedDate
    ? dateService.formatDateTime(plannedDate)
    : `-----`;

  return translations.replace("#{plannedDateString}", formattedDate);
};

const getPlannedDateTitle = (plannedDate: Date | null) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .insertNodeAfter.dateTemplateText;

  const formattedDate = plannedDate
    ? dateService.formatDateTime(plannedDate)
    : `-----`;

  return translations.replace("#{plannedDateString}", formattedDate);
};

const getHaltingTimeLabel = (haltingTime: number) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .insertNodeAfter.haltingTimeTemplateText;

  const formattedHaltingTime = durationService.format(haltingTime);

  return translations.replace("#{haltingTime}", formattedHaltingTime);
};

const getHaltingTimeTitle = (haltingTime: number) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .insertNodeAfter.haltingTimeTemplateText;

  const formattedHaltingTime = durationService.format(haltingTime);

  return translations.replace("#{haltingTime}", formattedHaltingTime);
};

const orderDetailsHistoryEntryChangeRideContentInsertNodeAfterHelper = {
  getAddressLabel,
  getAddressTitle,
  getPlannedDateLabel,
  getPlannedDateTitle,
  getHaltingTimeLabel,
  getHaltingTimeTitle,
};

export default orderDetailsHistoryEntryChangeRideContentInsertNodeAfterHelper;
